import { FC } from 'react';
import styles from './AddCard.module.scss';

export interface AddCardProps {
  onClick: () => void;
  className?: string;
}

export const AddCard: FC<AddCardProps> = ({ onClick, className }) => (
  <div
    className={`${styles.addCard} ${className || ''}`}
    onClick={onClick}
  >
    <div className={styles.addIcon}>+</div>
  </div>
);
